import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnChartPath = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M3.116 15.667h17.768m0 0L17.5 12.333m3.384 3.334L17.5 19m0-11.667h-6.77a3.4 3.4 0 0 0-2.392.977 3.3 3.3 0 0 0-.991 2.357v5M17.5 7.333 14.115 4M17.5 7.333l-3.385 3.334"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnChartPath;
